import { Prompt } from "../../types/prompts";

export const sortedPromptsByWeeklyScores = (prompts: Prompt[]) => {
  return prompts.sort((a, b) => {
    if (!a.weeklyScores) return -1;
    if (!b.weeklyScores) return 1;

    return b.weeklyScores.current_week_avg_visibility - a.weeklyScores.current_week_avg_visibility;
  });
};